const normalizeStage = (value?: string): string => {
  const normalized = (value ?? "dev").trim().toLowerCase();
  return normalized || "dev";
};

export const APP_ENV_STAGE = normalizeStage(process.env.REACT_APP_ENV_STAGE);

export const withEnvStage = (baseKey: string): string =>
  `${baseKey}_${APP_ENV_STAGE}`;